import { AxiosError, AxiosResponse } from 'axios';
import { DownloadedFileDTO } from './dto/DownloadedFileDTO';
import { extractFileNameFromHeader } from './fileDownloadUtil';
import Connector from '../../agent';

const DOWNLOAD_ENDPOINT = 'files/download?fileId=';

function safeQueryHandler(safeQuery: any) {
  return safeQuery
    .then((response: { data: File; headers: any }) => {
      const fileName = extractFileNameFromHeader(response as AxiosResponse);
      return { data: response.data, fileName };
    })
    .catch((error: AxiosError) => {
      const enc = new TextDecoder('utf-8');
      const err = error as AxiosError;
      throw new Error(enc.decode(err.response?.data as BufferSource));
    });
}

export function downloadFileCommonForPreview(endpoint: string) {
  const safeQuery = Connector.api._safeQuery(
    Connector.api._axios.get,
    endpoint,
    null,
    null,
    false,
    false,
    {
      responseType: 'blob',
    }
  );
  return safeQueryHandler(safeQuery);
}

export function downloadFileCommon(endpoint: string) {
  const safeQuery = Connector.api._safeQuery(
    Connector.api._axios.get,
    endpoint,
    null,
    null,
    false,
    false,
    {
      responseType: 'blob',
      headers: { Accept: 'application/pdf;charset=UTF-8' },
    }
  );
  return safeQueryHandler(safeQuery);
}

export function downloadFileForPreview(id: number): Promise<DownloadedFileDTO> {
  return downloadFileCommonForPreview(`${DOWNLOAD_ENDPOINT}${id}`);
}

export function downloadFile(id: number): Promise<DownloadedFileDTO> {
  return downloadFileCommon(`${DOWNLOAD_ENDPOINT}${id}`);
}
